"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShortTimeCell = exports.TimeCell = exports.timeCellFactory = void 0;
const react_1 = __importStar(require("react"));
const date_fns_1 = require("date-fns");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const locale_context_1 = require("../../../providers/locale/locale-context");
const date_utils_1 = require("../../../utils/date-utils");
const table_context_1 = require("../table-context");
function timeCellFactory({ showSeconds = true, displayName, }) {
    const TimeCell = function TimeCell({ value, }) {
        const { classes } = (0, react_1.useContext)(table_context_1.TableContext);
        const { locale } = (0, react_1.useContext)(locale_context_1.LocaleContext);
        const parsed = (0, date_utils_1.parseISOTimeSafe)(value);
        const date = parsed
            ? (0, date_fns_1.format)(parsed, showSeconds ? locale.timeFormat : locale.shortTimeFormat)
            : '';
        return react_1.default.createElement(Typography_1.default, { className: classes.tableCell }, date);
    };
    TimeCell.displayName = displayName;
    return TimeCell;
}
exports.timeCellFactory = timeCellFactory;
exports.TimeCell = timeCellFactory({
    showSeconds: true,
    displayName: 'TimeCell',
});
exports.ShortTimeCell = timeCellFactory({
    showSeconds: false,
    displayName: 'ShortTimeCell',
});
//# sourceMappingURL=time-cell.js.map